import { Component, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { msalConfiguration } from '../../../../assets/config/msal-config';

@Component({
  selector: 'shared-navuser',
  standalone: false,
  templateUrl: './navuser.component.html',
  styleUrl: './navuser.component.scss'
})

export class NavuserComponent {
  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private msalService: MsalService,
    private router: Router
  ) {}

  ngAfterViewInit(): void {
    const button = this.el.nativeElement.querySelector('.nav-user__button');
    const dropdown = this.el.nativeElement.querySelector('.nav-user__dropdown');
    const container = this.el.nativeElement.querySelector('.nav-user__container');

    if (button && dropdown) {
      this.renderer.listen(button, 'click', () => {
        this.renderer.addClass(dropdown, 'is-active');
      });

      this.renderer.listen(document, 'click', (event: Event) => {
        if (!container.contains(event.target)) {
          this.renderer.removeClass(dropdown, 'is-active');
        }
      });
    }
  }

  closeSession(){
    this.msalService.logout({
      postLogoutRedirectUri: msalConfiguration.postLogoutRedirectUri
    });
  }

  goToJiraConfig(event: Event): void {
    event.preventDefault();
    this.closeDropdown();
    this.router.navigate(['/jira-config']);
  }

  private closeDropdown(): void {
    const dropdown = this.el.nativeElement.querySelector('.nav-user__dropdown');
    if (dropdown) {
      this.renderer.removeClass(dropdown, 'is-active');
    }
  }
}
